import { render, staticRenderFns } from "./ResultadoExportacaoComSucessoDialog.vue?vue&type=template&id=3b1ce4a7"
import script from "./ResultadoExportacaoComSucessoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadoExportacaoComSucessoDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports